import { Link } from '@h2/common/components/link'

const SimilarMajors = ({ profile }) => {
  const listWithout = profile?.similarMajors?.filter(
    major => major.cipCode !== profile.cipCode
  )

  return (
    <div className="section" id="collegeinfo">
      <ul style={{ columnCount: '2' }}>
        {listWithout.map((major, idx) => (
          <li key={`major-${idx}`}>
            <Link href={major.majorDetailUrl}>{major.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export { SimilarMajors }
